<script setup>
import Toast from "primevue/toast";
</script>

<template>
  <Toast />
  <router-view />
</template>